import React, { useState } from "react";
import styled from "styled-components";
import { Button, PhotoDropzone } from "../ui-kit/styled-templates";
import "react-quill/dist/quill.snow.css";
import { Control } from "../ui-kit/control";

export default function PartnerForm(props) {
    const {
        onSave = d => {

        },
        onDelete = () => {

        }
    } = props;

    const [name, setName] = useState(props.name || "");
    const [description, setDescription] = useState(props.description || "");

    const [topText, setTopText] = useState(props.topText || '');

    const [services, setServices] = useState(props.services || "");
    const [url, setUrl] = useState(props.url || "");
    const [avatar, setAvatar] = useState(props.avatar);
    const [contacts, setContacts] = useState(props.contacts || "");
    const [attachmentUrl, setAttachmentUrl] = useState(props.attachmentUrl || "");


    return (
        <Wrapper>

            <Row>
                <Control.Input
                    value={name}
                    label={"Название"} placeholder={""} isRequired
                    onChange={evt => {
                        setName(evt.target.value);
                    }}
                />
            </Row>

            <Row>
                <Control.File name="avatar" accept="image/jpeg, image/png" className={"avatar_placeholder"}
                              onChange={evt => {
                                  setAvatar(evt.target.value);
                              }}
                >
                    {avatar == undefined ? <PhotoDropzone /> :
                        <AvaImg src={avatar} />
                    }

                </Control.File>
            </Row>

            <Row>
                <Control.Input
                    value={topText}
                    label={"Верхний текст"} placeholder={""} isRequired
                    onChange={evt => {
                        setTopText(evt.target.value);
                    }}
                />
            </Row>

            {/*<Row>*/}
            {/*    <Label>*/}
            {/*        Описание*/}
            {/*    </Label>*/}
            {/*    <ReactQuill*/}
            {/*        formats={formats}*/}
            {/*        value={description} onChange={a => {*/}
            {/*        setDescription(a);*/}
            {/*    }} />*/}
            {/*</Row>*/}

            {/*<Row>*/}
            {/*    <Label>*/}
            {/*        Описание сферы деятельности*/}
            {/*    </Label>*/}
            {/*    <Textarea value={description} onChange={evt => {*/}
            {/*        setDescription(evt.target.value);*/}
            {/*    }} />*/}
            {/*</Row>*/}

            {/*<Row>*/}
            {/*    <Label>*/}
            {/*        Услуги*/}
            {/*    </Label>*/}
            {/*    <Textarea value={services} onChange={evt => {*/}
            {/*        setServices(evt.target.value);*/}
            {/*    }} />*/}
            {/*</Row>*/}

            <Row>
                <Label>
                    Сайт
                </Label>
                <Input value={url} onChange={evt => {
                    setUrl(evt.target.value);
                }} />
            </Row>

            <Row>
                <Label>
                    Контакты
                </Label>
                <Textarea value={contacts} onChange={evt => {
                    setContacts(evt.target.value);
                }} />
            </Row>


            <div>
                <Button onClick={() => {
                    onSave({
                        name,
                        avatar,
                        topText,
                        description,
                        contacts,
                        services,
                        url,
                        attachmentUrl
                    });
                }}>
                    Сохранить
                </Button>
            </div>

            <div style={{ marginTop: 20, marginBottom: 20 }}>
                <DeleteSpan onClick={() => {
                    onDelete();
                }}>
                    Удалить
                </DeleteSpan>
            </div>

        </Wrapper>
    );
}

const DeleteSpan = styled.div`
  cursor: pointer;
  color: red;
  opacity: 0.7;

  :hover {
    opacity: 1;
  }
`;

const Wrapper = styled.div`

`;

const AvaImg = styled.img`
  //height: 400px;
`;


const Row = styled.div`
  margin-bottom: 10px;
`;

const Label = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
`;

const Input = styled.input`
  box-sizing: border-box;
  width: 100%;
  outline: none;
  border: 1px solid whitesmoke;

  :focus {
    border-color: blue;
  }
`;

const Textarea = styled.textarea`
  box-sizing: border-box;
  width: 100%;
  outline: none;
  border: 1px solid whitesmoke;

  :focus {
    border-color: blue;
  }
`;